module.exports = __webpack_public_path__ + "media/36.92040bb6.mp3";